/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Zachary Kay",
  title: "Hi, I'm Zachary",
  subTitle: emoji(
    "I aspire to continuously advance my skills as a web developer and pursue new programming languages and frameworks. Currently specialized in front-end development but eager to learn more, with particular interests in web design and development, blockchain development, and Web 3.0."
  ),
  resumeLink:
    "https://drive.google.com/file/d/16YpeXLZ5rOwx_L2db5mAtiFWAl4J6Pk6/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/zacharykay",
  linkedin: "https://www.linkedin.com/in/zachary-kay-425234188/",
  gmail: "zkay.ca@gmail.com",
  instagram: "https://www.instagram.com/zachokay",
  // gitlab: '',
  // facebook: '',
  // medium: '',
  // stackoverflow: '',
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FRONT-END WEB DEVELOPER & ENGINEER",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for web and mobile applications"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "TypeScript",
      customIcon: "SiTypescript"
    },
    {
      skillName: "Next.js",
      customIcon: "SiNextDotJs"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "MongoDB",
      customIcon: "SiMongodb"
    },

    {
      skillName: "JEST & Testing",
      customIcon: "SiJest"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "GitHub",
      customIcon: "SiGithub"
    },
    {
      skillName: "Photoshop",
      customIcon: "SiAdobephotoshop"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Bachelors in Marketing & International Business",
      logo: require("./assets/images/csulb-logo.png"),
      subHeader: "California State University Long Beach",
      duration: "2014 - 2017"
      // desc: '',
      // descBullets: [
      // 	'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      // 	'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
      // ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Web Developer",
      company: "Travonga.com",
      companylogo: require("./assets/images/Travonga-O-640-60.jpg"),
      date: "Apr 2018 – Present",
      // desc: "Developed website from idea to production. Upgraded site with better and cleaner coding solutions as I learned more advanced frameworks, techniques, and skills. Converted project from WordPress site to Vanilla JS and later into Node.js & EJS stack. Finally revamped project into React / Next.js stack that is highly organized and scalable utilizing, mobile-first responsive design, SSR API fetching fetching from custom JSON data, and SEO optimization. Everything coded from scratch including more complex components and features such as a multi-slide responsive carousel. Edited countless photos with Photoshop and optimized for web, properly accredited to abide by copyright laws. Extensive use of Google Maps and maps integration with custom place lists that can be saved and shared, satellite geo-mapping of unmarked places",
      descBullets: [
        "Developed website from idea to production, everything coded from scratch including more complex components and features including a multi-slide responsive carousel.",
        "Upgraded site with better and cleaner coding solutions as I learned more advanced frameworks, techniques, and skills",
        "Converted project from WordPress site to Vanilla JS and later into Node.js & EJS stack",
        "Finally revamped project into React / Next.js stack that is highly organized and scalable utilizing, mobile-first responsive design, SSR API fetching from custom JSON data, and SEO optimization",
        "Edited countless photos with Photoshop and optimized for web, properly credited to abide by copyright laws",
        "Extensive use of Google Maps and maps integration with custom place lists that can be saved and shared, satellite geo-mapping of unmarked places"
      ]
    },
    {
      role: "Web Designer, Content Writer",
      company: "CleverPy Machine Learning",
      companylogo: require("./assets/images/cleverpy-logo.jpg"),
      date: "Jun 2019 - Aug 2019",
      // desc: "Assisted with website design and layout. Researched and wrote technical articles on Machine Learning, Artificial Intelligence, and Industry 4.0. Helped team brainstorm concepts for real machine learning apps to be utilized by CleverPy's clients in a variety of industries. Edited and optimized photos for CleverPy's website and blog.",
      descBullets: [
        "Assisted with website design and layout",
        "Researched and wrote technical articles on Machine Learning, Artificial Intelligence, and Industry 4.0",
        "Helped team brainstorm concepts for real machine learning apps to be utilized by CleverPy's clients in a variety of industries",
        "Edited and optimized photos for CleverPy's website and blog"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Personal projects developed 100% by me",
  projects: [
    {
      image: require("./assets/images/Travonga-Screenshot.jpg"),
      projectName: "Travonga.com",
      projectDesc:
        "Massive project built with Next.js + React.js stack using custom JSON API and meticulously planned data structure, allowing for extreme versatility in templating. Travel itineraries and attraction guides for many destinations with countless photos edited with Photoshop.",
      footerLink: [
        {
          name: "Visit Travonga",
          url: "https://travonga.netlify.app"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Crypto-Investor-Screenshot.jpg"),
      projectName: "Crypto Porfolio Tracker",
      projectDesc:
        "React.js project with Cypress Testing integration, CoinGeckoAPI data fetching to populate fields, styled-components, and Auth0. Choose an initial investment across multiple cryptocurrencies and track your portfolio's value over time.",
      footerLink: [
        {
          name: "Visit CryptoInvestor",
          url: "https://crypto-investor.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/Euro-Tours-Screenshot.png"),
      projectName: "Euro Tours",
      projectDesc:
        "Full-stack TypeScript MERN application (MongoDB, Express, React, and Node.js) fetching from custom API database, utilizing SASS, Auth0, and MongoDB Atlas. Filter through a selection of European tours, with Cart functionality coming soon.",
      footerLink: [
        {
          name: "Visit EuroTours",
          url: "https://eurotours.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/Ultimate-Pokedex-Screenshot.jpg"),
      projectName: "Ultimate Pokedex",
      projectDesc:
        "React & TypeScript app with extensive SASS styling. Utilizes Poke API. All 9 buttons work and have different functions. Inspiration was to design a cross between a Gameboy and Pokedex, with many components' styling inspired by the old games.",
      footerLink: [
        {
          name: "Visit UltimatePokedex",
          url: "https://ultimatepokedex.netlify.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Technical Cetificates"),
  // subtitle:
  // 	'Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !',

  achievementsCards: [
    {
      title: "Modern Javascript Bootcamp 2020",
      image: require("./assets/images/udemy-javascript.jpg"),
      footerLink: [
        {
          name: "Digital Certificate",
          url: "https://www.udemy.com/certificate/UC-5a45978c-4ac7-4ce6-883c-3ba725951e32/"
        }
      ]
    },
    {
      title: "Web Developer Bootcamp 2020",
      image: require("./assets/images/udemy-web-developer.jpg"),
      footerLink: [
        {
          name: "Digital Certificate",
          url: "https://www.udemy.com/certificate/UC-fa77ff03-3186-4d01-b3a5-18a1b1f09a1a/"
        }
      ]
    },
    {
      title: "React Projects Course",
      image: require("./assets/images/udemy-react.jpg"),
      footerLink: [
        {
          name: "Digital Certificate",
          url: "https://www.udemy.com/certificate/UC-2d6730d2-aa55-4681-a533-89db61a5b7d6/"
        }
      ]
    },
    {
      title: "MERN Fullstack Guide",
      image: require("./assets/images/udemy-mern.jpg"),
      footerLink: [
        {
          name: "Digital Certificate",
          url: "https://www.udemy.com/certificate/UC-c98b3968-b806-41d0-91f3-646666596a55/"
        }
      ]
    },

    {
      title: "Data Structures & Algorithms",
      // subtitle: '',
      image: require("./assets/images/udemy-ztm.jpg"),
      footerLink: [
        {
          name: "Digital Certificate",
          url: "https://www.udemy.com/certificate/UC-22aa669f-1962-4a0a-acfc-c507225c38dd/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: '+92-3243454077',
  email_address: "zkay.ca@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
